module.exports = __webpack_public_path__ + "img/DUR.6473da36.png";